
import { defineComponent, PropType, ref } from 'vue'
import InputError from '@/components/ui/InputError.vue'
import { checkErrorsReturn } from '@/use/validInput'
import { theme } from '@/config/styles'

/**
 * Component utilizado para input de texto/numerico
 * @prop {Boolean} isInvalid - Condição para verficar se o input é válido
 * @prop {Array<String>} errors - Array de string contendo todos
 * as mensagens de erros
 * @event inputEvent - Evento para quando algo é escrito no input
 */
const __default__ = defineComponent({
    components: {
        InputError,
    },
    props: {
        isInvalid: {
            type: Boolean,
            default: false,
        },
        errors: {
            type: Array as PropType<string[]>,
            default: () => {
                return ['']
            },
        },
        name: {
            type: String,
            required: true
        },
        modelValue: {
            type: [String],
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
    },
    emits: ['inputEvent'],
    inheritAttrs: false,
    setup(props, context) {
        const inFocus = ref(false)
        const outFocus = ref(true)
        const filled = ref(false)
        /**
         * Função chamada para emitir um evento quando algo é escrito no input
         * @param {any} event - dados do evento recebido pelo input
         */
        function onInput(event: Event) {
            context.emit('inputEvent', (event.target as HTMLInputElement).value)
        }

        function changeFilled()
        {
            if (props.modelValue.length != 0)
                filled.value = true
            else
                filled.value = false
        }
        function focusInput() {
            inFocus.value = true
            outFocus.value = false
            changeFilled()
        }
        function outFocusInput() {
            inFocus.value = false
            outFocus.value = true
            changeFilled()
        }


        return {
            checkErrorsReturn,
            onInput,
            focusInput,
            outFocusInput,
            inFocus,
            outFocus,
            filled,
            theme
        }
    },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "00ab87fe": (_ctx.theme.colors.primary.midlight),
  "fe880e36": (_ctx.theme.colors.white),
  "32eced9c": (_ctx.theme.colors.grays.lightest),
  "8a0d07d0": (_ctx.theme.colors.primary.mid)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__